import React from "react";
import Image from "next/image";
import IMAGES from "@/public/assets/img";

const features = [
  {
    icon: IMAGES.termsheet.secure,
    title: "Avoid Late Payment",
    description: "Secure your transactions with reliable data.​",
  },
  {
    icon: IMAGES.termsheet.quick,
    title: "Smarter Decisions​",
    description: "Choose the right buyers with confidence.​",
  },
  {
    icon: IMAGES.termsheet.security,
    title: "Enhance Security​",
    description: "Protect your cash flow and minimize risks.​",
  },
];

const ExporterRisk = () => {
  return (
    <section className="py-[100px]">
      <div className="container xm:px-2 px-3">
        <div className="flex justify-between w-full gap-3 items-center sm:flex-col">
          <div className="flex sm:flex-row flex-wrap gap-2 w-3/5 sm:w-full">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white border border-[#C4C4C4] rounded-2xl p-2 w-[30%] sm:w-full"
              >
                <Image
                  src={feature.icon}
                  alt={feature.title}
                  width={60}
                  height={60}
                  className="mb-1"
                />
                <h3 className="font-semibold text-lg text-gray-900 mb-2 max-h-12">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-base">{feature.description}</p>
              </div>
            ))}
          </div>
          <div className="w-2/5 sm:w-full sm:mt-6">
            <h2 className="text-xxl font-bold text-black">
              Avoid Risks: The Smart <br /> Exporter's Choice​
            </h2>
            <p className="mt-2 text-[#6F6F6F] text-lg">
              Smart exporters trust Credlix to safeguard transactions. Avoid
              late payments and make informed decisions. Protect your cash flow
              and enhance financial security.​
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExporterRisk;
